export function conciergeTitle(country: string, centreSlug: string): string {
  if (centreSlug === 'newmarket') {
    return 'Guest Services'
  }
  return country === 'New Zealand' ? 'Customer Service' : 'Concierge'
}
